import { countries } from '../constants'

export const countriesWithLineOfBusiness = [countries.CL]

export const checkIfLineOfBusinessIsAvailable = (vendorCountryCode: string) => {
  return countriesWithLineOfBusiness.includes(vendorCountryCode)
}
